import { cn } from "@/lib/tailwind";

const RecommendedBadge = ({ className, text }: { className?: string; text: string }) => {
  return (
    <div className={cn("w-max bg-primary-4 p-2", className)}>
      <div className="text-[0.75rem] font-semibold">{text}</div>
    </div>
  );
};

export default RecommendedBadge;
